module.exports = __webpack_public_path__ + "img/lsmu-logo-white.1755231d.svg";